import { ArcgisCivil3dPropertyMappingApiModel } from './arcgis-civil3d-property-mapping.model';
import { ArcgisCivil3dSettingApiModel } from './arcgis-civil3d-setting.model';
import { AutodeskLayerApiModel } from './autodesk-layer.model';
import { ParcelStyleApiModel } from './parcel-style.model';

export type ArcgisCivil3dParcelSettingApiModel = ArcgisCivil3dSettingApiModel & {
  site: string;
  parcelStyle: { id: number } | null;
  autodeskLayer: { id: number } | null;
};

export type WithParcelStyle = ArcgisCivil3dParcelSettingApiModel & {
  parcelStyle: ParcelStyleApiModel | null;
};

export type WithAutodeskLayer = ArcgisCivil3dParcelSettingApiModel & {
  autodeskLayer: (Pick<AutodeskLayerApiModel, 'id'> & { name: string }) | null;
};

export type WithPropertyMappings = ArcgisCivil3dParcelSettingApiModel & {
  propertyMappings: ArcgisCivil3dPropertyMappingApiModel[];
};

export enum ArcgisCivil3dParcelSettingRelationship {
  CONFIGURATION = 'CONFIGURATION',
  ARCGIS_FEATURE_CLASS = 'ARCGIS_FEATURE_CLASS',
  PARCEL_STYLE = 'PARCEL_STYLE',
  AUTODESK_LAYER = 'AUTODESK_LAYER',
  PROPERTY_MAPPINGS = 'PROPERTY_MAPPINGS',
}
